import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from './calendar.component';
import {Component} from '@angular/core';
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  declarations: [
    CalendarComponent
  ],
  imports: [
    CommonModule,
    NgbPopoverModule
  ],
  exports: [
    CalendarComponent,
  ],
})
export class CalendarModule { }
